export default {
  title: 'Valuri',
  actions: {
    create: 'Creează un val',
    delete: 'Eliminați acest val'
  },
  step: {
    create: 'Creați un pas',
    edited: 'Editați un pas'
  },
  deletion: {
    message: 'Ești sigur că vrei să suprimi acest val?'
  },
  empty: {
    title: 'Fără val',
    message: 'Pentru a crea un val, nimic nu poate fi mai simplu, trebuie doar să faceți clic pe următorul link:'
  },
  list: {
    name: 'numele de familie',
    status: 'stare',
    who: 'care',
    where: 'sau',
    when: 'când',
    reward: 'Răsplată'
  }
}



// WEBPACK FOOTER //
// ./src/translations/ro/waves.js